import Buttons from "views/Components/Buttons.js";
import Calendar from "views/Calendar/Calendar.js";
import Charts from "views/Charts/Charts.js";
import Dashboard from "views/Dashboard/Dashboard.js";
import ErrorPage from "views/Pages/ErrorPage.js";
import ExtendedForms from "views/Forms/ExtendedForms.js";
import ExtendedTables from "views/Tables/ExtendedTables.js";
import FullScreenMap from "views/Maps/FullScreenMap.js";
import GoogleMaps from "views/Maps/GoogleMaps.js";
import GridSystem from "views/Components/GridSystem.js";
import Icons from "views/Components/Icons.js";
import LockScreenPage from "views/Pages/LockScreenPage.js";
import LoginPage from "views/Pages/LoginPage.js";
import Notifications from "views/Components/Notifications.js";
import Panels from "views/Components/Panels.js";
import PricingPage from "views/Pages/PricingPage.js";
import RTLSupport from "views/Pages/RTLSupport.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import RegularForms from "views/Forms/RegularForms.js";
import ReactTables from "views/Tables/ReactTables.js";
import RegularTables from "views/Tables/RegularTables.js";
import SweetAlert from "views/Components/SweetAlert.js";
import TimelinePage from "views/Pages/Timeline.js";
import Typography from "views/Components/Typography.js";
import UserProfile from "views/Pages/UserProfile.js";
import ValidationForms from "views/Forms/ValidationForms.js";
import VectorMap from "views/Maps/VectorMap.js";
import Widgets from "views/Widgets/Widgets.js";
import Wizard from "views/Forms/Wizard.js";
// User Views
import UsersTable from "views/Users/UsersTable.js";
import NewUser from "views/Users/NewUser";
import EditUser from "views/Users/EditUser";

// Codesets Views
import CodesetsTable from "views/Codesets/CodesetsTable.js";
import NewCodeset from "views/Codesets/NewCodeset";
import EditCodeset from "views/Codesets/EditCodeset";

import CopyCodeset from "views/Codesets/CopyCodeset";

//
import SectionsTable from "views/Codesets/SectionsTable.js";
import NewSection from "views/Codesets/NewSection";
import EditSection from "views/Codesets/EditSection";

import SignsTable from "views/Codesets/SignsTable.js";
import NewSign from "views/Codesets/NewSign";
import EditSign from "views/Codesets/EditSign";

import TypesTable from "views/PropertyTypes/TypesTable.js";
import NewProperty from "views/PropertyTypes/NewProperty.js";
import EditProperty from "views/PropertyTypes/EditProperty.js";

import ReportsTable from "views/Codesets/ReportsTable";
import Report from "views/Codesets/Report";
import Images from "views/Codesets/Images";

import import_page from "views/Codesets/import_page";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import GridOn from "@material-ui/icons/GridOn";
import GraphicEqIcon from "@material-ui/icons/GraphicEq";
import FolderIcon from "@material-ui/icons/Folder";
import PersonIcon from "@material-ui/icons/Person";
import LayersIcon from "@material-ui/icons/Layers";
import AccessibleIcon from "@material-ui/icons/Accessible";


var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin"
  }, 
  {
    path: "/reports",
    name: "Reports",
    rtlName: "الحاجيات",
    icon: GraphicEqIcon,
    component: ReportsTable,
    layout: "/admin"
  },
  {
    path: "/code_sets",
    name: "Code Sets",
    rtlName: "الرسوم البيانية",
    icon: AccessibleIcon,
    component: CodesetsTable,
    layout: "/admin"
  },
  {
    path: "/property_types",
    name: "Property Types",
    rtlName: "التقويم",
    icon: LayersIcon,
    component: TypesTable,
    layout: "/admin"
  },
  {
    path: "/users",
    name: "Users",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: UsersTable,
    layout: "/admin"
  },
  {
    path: "/login-page",
    name: "Login Page",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    component: LoginPage,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/new-user",
    name: "New User",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: NewUser,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/edit-user/:id",
    name: "Edit User",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: EditUser,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/new-codeset",
    name: "New Code Set",
    icon: PersonIcon,
    component: NewCodeset,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/copy-codeset/:id",
    name: "Copy Code Set",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: CopyCodeset,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/edit-codeset/:id",
    name: "Edit Code Set",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: EditCodeset,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/sections/:id",
    name: "Codesets",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: SectionsTable,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/new-section/:id",
    name: "New Section",
    icon: PersonIcon,
    component: NewSection,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/edit-section/:id",
    name: "Edit Section",
    icon: PersonIcon,
    component: EditSection,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/signs/:id",
    name: "Signs",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: SignsTable,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/new-sign/:id",
    name: "New Sign",
    icon: PersonIcon,
    component: NewSign,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/edit-sign/:id",
    name: "Edit Sign",
    icon: PersonIcon,
    component: EditSign,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/new-property",
    name: "New Property Type",
    icon: PersonIcon,
    component: NewProperty,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/edit-property/:id",
    name: "Edit Property",
    icon: PersonIcon,
    component: EditProperty,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/import_page/",
    name: "Edit Property",
    icon: PersonIcon,
    component: import_page,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/report/:id/:type",
    name: "Report",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: Report,
    layout: "/admin",
    redirect: true
  },
  {
    path: "/images/:id",
    name: "Images",
    rtlName: "التقويم",
    icon: PersonIcon,
    component: Images,
    layout: "/admin",
    redirect: true
  },

];
export default dashRoutes;
